import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/dashboard/'
import Login from '../pages/login'

////rutas del dashboard/////

  import Home_dashboard from '../pages/dashboard/pages/content/home.vue'
  import reporte_dashboard from '../pages/dashboard/pages/content/reportes.vue'
  
  
  import usuario_dashboard from '../pages/dashboard/pages/content/usuarios.vue'
  import usuario_dashboard_lista from '../pages/dashboard/pages/content/subrutas/usuarios/lista.vue'
  import usuario_dashboard_create from '../pages/dashboard/pages/content/subrutas/usuarios/create.vue'
  
  import usuarioapp_dashboard_lista from '../pages/dashboard/pages/content/subrutas/usuarios/app/lista.vue'
   
  ////
  import vehiculo_dashboard from '../pages/dashboard/pages/content/vehiculo.vue'
  import vehiculo_dashboard_subruta_lista from '../pages/dashboard/pages/content/subrutas/vehiculos/lista_vehiculos.vue'
  import vehiculo_dashboard_subruta_crear from '../pages/dashboard/pages/content/subrutas/vehiculos/create_vehiculos.vue'


  import conductor_dashboard from '../pages/dashboard/pages/content/conductores.vue'
  import conductor_dashboard_subruta_lista from '../pages/dashboard/pages/content/subrutas/drivings/lista_conductores.vue'
  import conductor_dashboard_subruta_crear from '../pages/dashboard/pages/content/subrutas/drivings/crear_conductores.vue'


  import asignacion_dashboard from '../pages/dashboard/pages/content/asignacion.vue'
  import asignacion_dashboard_subrutas_lista from '../pages/dashboard/pages/content/subrutas/asignacion/lista'
  import asignacion_dashboard_subrutas_create from '../pages/dashboard/pages/content/subrutas/asignacion/create'

  import registro_dashboard from '../pages/dashboard/pages/content/registro.vue'
  import registro_dashboard_subrutas_lista from '../pages/dashboard/pages/content/subrutas/registros/lista.vue'
  import registro_dashboard_subrutas_create from '../pages/dashboard/pages/content/subrutas/registros/create.vue'
  import registro_dashboard_subrutas_reporte from '../pages/dashboard/pages/content/subrutas/registros/reporte.vue'
  



  import config_dashboard from '../pages/dashboard/pages/content/config.vue'
  import config_dashboard_lista_total_configuraciones from '../pages/dashboard/pages/content/subrutas/config/lista_config.vue'
  import config_dashboard_sucursales from '../pages/dashboard/pages/content/subrutas/config/sucursales/'
  import config_dashboard_empresa from '../pages/dashboard/pages/content/subrutas/config/empresas/'

  import exepcion_dashboard from '../pages/dashboard/pages/content/exeption.vue'
  import exepcion_dashboard_lista from '../pages/dashboard/pages/content/subrutas/exeptions/lista.vue'
  import exepcion_dashboard_create from '../pages/dashboard/pages/content/subrutas/exeptions/create.vue' 

////////////////////////////

Vue.use(VueRouter)

const routes = [
   

  {
    path: '*',
    redirect:'/'
  },
  {
    path: '/',
    name: 'layout',
    component: Home,
    children: [
      {
        path: '/',
        name: 'home',
        redirect:'/registro',
        component: Home_dashboard,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: '/registro',
        name: 'registro',
        component: registro_dashboard,
        meta: {
          requiresAuth: true
        },
        children:[
          {
            path: '/',
            name: 'lista_registro',
            component: registro_dashboard_subrutas_lista,
          },
          {
            path: '/registro/crear',
            name: 'crear_registro',
            component: registro_dashboard_subrutas_create
          },
          {
            path: '/registro/reporte',
            name: 'reporte_registro',
            component: registro_dashboard_subrutas_reporte
          }
        ]
      },
      {
        path: '/reporte',
        name: 'reporte',
        component: reporte_dashboard,
        meta: {
          requiresAuth: true
        },
     
      },

      {
        path: '/usuarios',
        name: 'usuarios',
        component: usuario_dashboard,
        meta: {
          requiresAuth: true
        },
        children:[
          {
            path: '/',
            name: 'lista_usuarios',
            component: usuario_dashboard_lista,
          },
          {
            path: '/usuarios/crear',
            name: 'create_usuarios',
            component: usuario_dashboard_create

          },
          {
            path: '/usuariosapp',
            name: 'lista_usuariosapp',
            component: usuarioapp_dashboard_lista,
          },
          
      ]
      },

      

      {
        path: '/vehiculo',
        name: 'vehiculo',
        component: vehiculo_dashboard,
        meta: {
          requiresAuth: true
        },
        children:[
          {
            path: '/',
            name: 'lista_vehiculos',
            component: vehiculo_dashboard_subruta_lista,
          },
          {
            path: '/vehiculo/crear',
            name: 'crear_vehiculos',
            component: vehiculo_dashboard_subruta_crear
          }
        ]
      },

      

      {
        path: '/config',
        name: 'config',
        component: config_dashboard,
        meta: {
          requiresAuth: true
        },
        children:[
          {
            path: '/',
            name: 'lista_config',
            component: config_dashboard_lista_total_configuraciones,
          },
          {
            path: '/config/sucursales',
            name: 'config_sucursales',
            component: config_dashboard_sucursales
          },
          {
            path: '/config/empresas',
            name: 'config_empresas',
            component: config_dashboard_empresa
          }

        ]
      },

      {
        path: '/conductor',
        name: 'conductor',
        component: conductor_dashboard,
        meta: {
          requiresAuth: true
        },
        children:[
          {
            path: '/',
            name: 'lista_conductores',
            component: conductor_dashboard_subruta_lista,
          },
          {
            path: '/conductor/crear',
            name: 'crear_conductores',
            component: conductor_dashboard_subruta_crear
          }
        ]
      },

      {
        path: '/exepciones',
        name: 'exepcion',
        component: exepcion_dashboard,
        meta: {
          requiresAuth: true
        },
        children:[
          {
            path: '/',
            name: 'lista_exepciones',
            component: exepcion_dashboard_lista,
          },
          {
            path: '/exepciones/crear',
            name: 'create_exepciones',
            component: exepcion_dashboard_create
          }
        ]
      },

      {
        path:'/asignacion',
        name: 'asignacion',
        component: asignacion_dashboard,
        meta: {
          requiresAuth: true
        },
        children:[
          {
            path: '/',
            name: 'lista_asignacion',
            component: asignacion_dashboard_subrutas_lista,
          },
          {
            path: '/asignacion/crear',
            name: 'crear_asignacion',
            component: asignacion_dashboard_subrutas_create
          }
        ]
      }

      
    ]
  },

  {
    path: '/login',
    name: 'login',
    component: Login
  },

]

const router = new VueRouter({
  //mode: 'history',
  routes,
})

export default router
